
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 12 12","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_8493_4578)"}},[_c('path',{attrs:{"d":"M10.133 1.106a1.175 1.175 0 00-1.662 0l-.762.761c.63.496 1.304.937 2.013 1.313l.411-.412a1.175 1.175 0 000-1.662zM4.242 5.334L.344 9.232a1.175 1.175 0 101.663 1.662l3.522-3.523a12.69 12.69 0 00-1.287-2.037z"}}),_c('path',{attrs:{"d":"M11.73 3.991c-1.854-.606-3.506-1.557-4.926-2.897a.392.392 0 00-.546.008L4.034 3.326a.392.392 0 00-.008.546c1.34 1.42 2.29 3.072 2.897 4.926a.39.39 0 00.377.27 4.785 4.785 0 003.31-1.39A4.784 4.784 0 0012 4.368a.392.392 0 00-.27-.377zM9.58 6.648c-.584.584-1.32 1-2.114 1.217a14.083 14.083 0 00-.308-.727 3.992 3.992 0 001.868-1.044 3.991 3.991 0 001.045-1.868c.239.11.481.212.726.308A4.776 4.776 0 019.58 6.648z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_8493_4578"}},[_c('path',{attrs:{"d":"M0 0h12v12H0z"}})])])])
          )
        }
      }
    